import { PLAN_KINDS } from './constants'
import type { PlanKind } from './types'

export const isSingleProjectPlan = (planKind?: PlanKind) =>
  planKind === PLAN_KINDS.single_project

export const isCreditsPlan = (planKind?: PlanKind) =>
  planKind === PLAN_KINDS.subscription || isSingleProjectPlan(planKind)
